import { useLocation } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';

import './index.css';

const ArtworkViewNavbar = () => {

  const goBackHandler = useGoBack("/");

  const { pathname } = useLocation(); 

  const isSuarteWorld = () => {
    return pathname?.includes("suarteworld");
  };

  return (
    <>
      {!isSuarteWorld() && <div className='artwork-view-navbar'>
        <div onClick={goBackHandler} className='artwork-view-navbar__go-back-container'>
          <BackArrowIcon className="artwork-view-header__go-back-button" />
          <p className='artwork-view-header__go-back-text'>Back</p>
        </div>
      </div>}
    </>
    
  );
};

export default ArtworkViewNavbar;